interface LegendModalProps {
  visible: boolean;
  onClose: () => void;
}

const LEGEND_TITLE = 'Risk Sınıflandırma Tablosu';
const COLUMNS = ['<50 Yaş', '50-69 Yaş', '≥70 Yaş'] as const;
const ROWS: { color: 'green' | 'orange' | 'red'; label: string; values: [string, string, string] }[] = [
  { color: 'green', label: 'Düşük', values: ['%2.5', '<%5', '<%7.5'] },
  { color: 'orange', label: 'Orta', values: ['%2.5 - <%7.5', '%5 - <%10', '%7.5 - <%15'] },
  { color: 'red', label: 'Yüksek', values: ['≥%7.5', '≥%10', '≥%15'] },
];
const DOT_COLORS = { green: 'bg-[#22C55E]', orange: 'bg-[#F59E0B]', red: 'bg-[#DC2626]' };

export function LegendModal({ visible, onClose }: LegendModalProps) {
  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center bg-black/50 sm:items-center"
      role="dialog"
      aria-modal="true"
      aria-labelledby="legend-modal-title"
    >
      <div
        className="animate-modal-content w-full max-w-md rounded-t-3xl bg-white/90 shadow-xl backdrop-blur-lg sm:rounded-3xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-border px-4 py-3">
          <h2 id="legend-modal-title" className="text-lg font-bold text-[#DC2626]">
            {LEGEND_TITLE}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="rounded p-1.5 text-[#DC2626] hover:bg-error-bg focus:outline-none focus:ring-2 focus:ring-primary"
            aria-label="Kapat"
          >
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="max-h-[70vh] overflow-y-auto px-4 py-4">
          <p className="mb-3 text-sm text-[#5C5C5C]">Yaşa göre risk eşikleri (10 yıllık KV risk, SCORE2)</p>
          <div className="overflow-x-auto">
            <table className="w-full min-w-[260px] border-collapse text-sm">
              <thead>
                <tr className="border-b border-border">
                  <th className="py-2 pr-2 text-left font-medium text-[#1A1A1A]"></th>
                  {COLUMNS.map((col) => (
                    <th key={col} className="py-2 px-2 text-center font-medium text-[#1A1A1A]">{col}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {ROWS.map((row) => (
                  <tr key={row.label} className="border-b border-border last:border-0">
                    <td className="py-2.5 pr-2">
                      <span className={`inline-block h-3 w-3 shrink-0 rounded-full ${DOT_COLORS[row.color]}`} aria-hidden />
                    </td>
                    <td className="py-2.5 px-2 text-center text-[#1A1A1A]">{row.values[0]}</td>
                    <td className="py-2.5 px-2 text-center text-[#1A1A1A]">{row.values[1]}</td>
                    <td className="py-2.5 px-2 text-center text-[#1A1A1A]">{row.values[2]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <button type="button" className="absolute inset-0 -z-10" aria-label="Kapat" onClick={onClose} />
    </div>
  );
}
